var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.291,
    height: 20.291,
    viewBox: "0 0 20.291 20.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropright-circle",
    "data-name": "Icon ionic-ios-arrow-dropright-circle",
    d: "M3.375,13.521A10.146,10.146,0,1,0,13.521,3.375,10.144,10.144,0,0,0,3.375,13.521Zm11.926,0L11.306,9.565a.942.942,0,0,1,1.332-1.332L17.291,12.9a.94.94,0,0,1,.029,1.3l-4.585,4.6A.94.94,0,1,1,11.4,17.471Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle_arrow.a7d539f6804ba5b8c1870dac932b8681.svg";
export { ForwardRef as ReactComponent };